import StayWorldly from './StayWorldly';
import Portfolio from './Portfolio';
import SevenBees from './SevenBees';
import Mike from './Mike';

const CompleteProjects = ()=>{
    return(
        <div>
            <br/>
            <Mike/>
            <SevenBees/>
            <StayWorldly/>
            <Portfolio/>
        </div>
    )
}

export default CompleteProjects;